import { render } from "./TemplateCreator.vue?vue&type=template&id=2affe075&scoped=true"
import script from "./TemplateCreator.vue?vue&type=script&lang=js"
export * from "./TemplateCreator.vue?vue&type=script&lang=js"

import "./TemplateCreator.vue?vue&type=style&index=0&id=2affe075&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2affe075"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSpinner});
